const VEHICLES_lIST = {
  totalCount: 6,
  items: [
    {
      vehicleId: "5050678",
      code: "AUTO-XQ97P5U1TE5X",
      dbId: 3,
      label: "2001 International (Garcia) Xirgo",
      registrationNumber: "1ABC124",
      currentDriver: null,
      primaryGroup: "Entire Fleet",
      year: null,
      make: null,
      hasNavigationDevice: false,
      boxOrderNUmber: 1575832,
      imei: 710100448,
      gsm: 5236423910,
      networkType: null,
      garminStatus: null,
      objectRowState: null,
      model: null,
      vin: "1N6BF0KM1LN804173", //Valid
      classification: "Vehicle (Default)",
      boxName: "Calamp",
      vehicleNumber: "AUTO-XQ97P5U1TE5X",
      lastPingDate: "2025-01-08T13:29:14.238Z",
    },
    {
      vehicleId: "5050688",
      code: "AUTO-XQ97P5U1TE5X",
      dbId: 3,
      label: "2001 International (Garciaa) Xirgo",
      registrationNumber: "1ABC224",
      currentDriver: null,
      primaryGroup: "Entire Fleet",
      year: null,
      make: null,
      hasNavigationDevice: false,
      boxOrderNUmber: 1575832,
      imei: 710100448,
      gsm: 5236423910,
      networkType: null,
      garminStatus: null,
      objectRowState: null,
      model: null,
      vin: "1N6BF0KM1LN804173", //Valid
      classification: "Vehicle (Default)",
      boxName: "Calamp",
      vehicleNumber: "AUTO-XQ97P5U1TE5X",
      lastPingDate: "2025-01-08T13:29:14.238Z",
    },
    {
      vehicleId: "5050670",
      code: "AUTO-XQ97P5U1TE5A",
      dbId: 4,
      label: "2002 International (Garciaa) Xirgo",
      registrationNumber: "1ABC225",
      currentDriver: null,
      primaryGroup: "Entire Fleet",
      year: null,
      make: null,
      hasNavigationDevice: false,
      boxOrderNUmber: 1575899,
      imei: 710100447,
      gsm: 5236423111,
      networkType: null,
      garminStatus: null,
      objectRowState: null,
      model: null,
      vin: "3AKJGLDR8JSJK5321", //Valid
      classification: "Vehicle (Default)",
      boxName: "Xirgo",
      vehicleNumber: "AUTO-XQ97P5U1TE5A",
      lastPingDate: "2025-01-08T13:29:14.238Z",
    },
    {
      vehicleId: "5050680",
      code: "AUTO-XQ97P5U1TD5A",
      dbId: 4,
      label: "2002 International (Garcia) Xirgo",
      registrationNumber: "1ABC125",
      currentDriver: null,
      primaryGroup: "Entire Fleet",
      year: null,
      make: null,
      hasNavigationDevice: false,
      boxOrderNUmber: 1575899,
      imei: 710100447,
      gsm: 5236423111,
      networkType: null,
      garminStatus: null,
      objectRowState: null,
      model: null,
      vin: "3AKJGLDR8JSJK5321", //Valid
      classification: "Vehicle (Default)",
      boxName: "Xirgo",
      vehicleNumber: "AUTO-XQ97P5U1TE5A",
      lastPingDate: "2025-01-08T13:29:14.238Z",
    },
    {
      vehicleId: "5050672",
      code: "AUTO-XQ97P5U1TE5B",
      dbId: 5,
      label: "Isuzu 2011 (Giovani) Xirgo",
      registrationNumber: "1ABC129",
      currentDriver: null,
      primaryGroup: "Entire Fleet",
      year: null,
      make: null,
      hasNavigationDevice: false,
      boxOrderNUmber: 1575833,
      imei: 710100448,
      gsm: 5236423911,
      networkType: null,
      garminStatus: null,
      objectRowState: null,
      model: null,
      vin: null, //Valid if this Vin( 54DC4J1D4PS204691 ) is provided
      classification: "Vehicle (Default)",
      boxName: "Xirgo",
      vehicleNumber: "AUTO-XQ97P5U1TE5B",
      lastPingDate: "2025-01-08T13:29:14.238Z",
    },
    {
      vehicleId: "5050679",
      code: "AUTO-XQ97P5U1TE5H",
      dbId: 5,
      label: "Isuzu 2012 (Giovani) VDD",
      registrationNumber: "1ABC129",
      currentDriver: null,
      primaryGroup: "Entire Fleet",
      year: null,
      make: null,
      hasNavigationDevice: false,
      boxOrderNUmber: 1575811,
      imei: 710100447,
      gsm: 5211423911,
      networkType: null,
      garminStatus: null,
      objectRowState: null,
      model: null,
      vin: null, //Valid if this Vin( 1FDRF3H69CEC06226 ) is provided
      classification: "Vehicle (Default)",
      boxName: "VDD",
      vehicleNumber: "AUTO-XQ97P5U1TE5H",
      lastPingDate: "2025-01-08T13:29:14.238Z",
    },
    {
      vehicleId: "5050673",
      code: "AUTO-XQ97P5U1TE5F",
      dbId: 7,
      label: "Isuzu 2013 (Giovani) Xirgo",
      registrationNumber: "1ABC130",
      currentDriver: null,
      primaryGroup: "Entire Fleet",
      year: null,
      make: null,
      hasNavigationDevice: false,
      boxOrderNUmber: 1575833,
      imei: 222010430,
      gsm: 5236423211,
      networkType: null,
      garminStatus: null,
      objectRowState: null,
      model: null,
      vin: "",
      classification: "Powered Asset",
      boxName: "Xirgo",
      vehicleNumber: "AUTO-XQ97P5U1TE5F",
      lastPingDate: "2025-01-08T13:29:14.238Z",
    },
    {
      vehicleId: "5050683",
      code: "AUTO-XQ97P5U1TE5F",
      dbId: 7,
      label: "Isuzu 2013 (Giovanii) Xirgo",
      registrationNumber: "1ABC130",
      currentDriver: null,
      primaryGroup: "Entire Fleet",
      year: null,
      make: null,
      hasNavigationDevice: false,
      boxOrderNUmber: 1575833,
      imei: 222010430,
      gsm: 5236423211,
      networkType: null,
      garminStatus: null,
      objectRowState: null,
      model: null,
      vin: "",
      classification: "Powered Asset",
      boxName: "Xirgo",
      vehicleNumber: "AUTO-XQ97P5U1TE5F",
      lastPingDate: "2025-01-08T13:29:14.238Z",
    },
    {
      vehicleId: "5050699",
      code: "AUTO-XQ97P5U1TE99",
      dbId: 7,
      label: "Isuzu 2014 (Giovani) Xirgo",
      registrationNumber: "1ABC139",
      currentDriver: null,
      primaryGroup: "Entire Fleet",
      year: null,
      make: null,
      hasNavigationDevice: false,
      boxOrderNUmber: 1575899,
      imei: 222010499,
      gsm: 5236423299,
      networkType: null,
      garminStatus: null,
      objectRowState: null,
      model: null,
      vin: "2G1WA5E30E1176591",
      classification: "Powered Asset",
      boxName: "Xirgo",
      vehicleNumber: "AUTO-XQ97P5U1TE5F",
      lastPingDate: "2025-01-08T13:29:14.238Z",
    },
    {
      vehicleId: "5050799",
      code: "AUTO-XQ97P5U1XE99",
      dbId: 7,
      label: "Isuzu 2014 (Giovanii) Xirgo",
      registrationNumber: "1ABC139",
      currentDriver: null,
      primaryGroup: "Entire Fleet",
      year: null,
      make: null,
      hasNavigationDevice: false,
      boxOrderNUmber: 1575899,
      imei: 222010499,
      gsm: 5236423299,
      networkType: null,
      garminStatus: null,
      objectRowState: null,
      model: null,
      vin: "2G1WA5E30E1176591",
      classification: "Powered Asset",
      boxName: "Xirgo",
      vehicleNumber: "AUTO-XQ97P5U1TE5F",
      lastPingDate: "2025-01-08T13:29:14.238Z",
    },
    {
      vehicleId: "5050671",
      code: "AUTO-XQ97P5U1TE5U",
      dbId: 4,
      label: "2003 International (Garcia) Xirgo DNR",
      registrationNumber: "1ABC125",
      currentDriver: null,
      primaryGroup: "Entire Fleet",
      year: null,
      make: null,
      hasNavigationDevice: false,
      boxOrderNUmber: 1575899,
      imei: 710100448,
      gsm: 5236473111,
      networkType: null,
      garminStatus: null,
      objectRowState: null,
      model: null,
      vin: "1N6BF0KM1LN804173", //Invalid - lastPingDate is null
      classification: "Vehicle (Default)",
      boxName: "Xirgo",
      vehicleNumber: "AUTO-XQ97P5U1TE5U",
      lastPingDate: null,
    },
    {
      vehicleId: "5050612",
      code: "AUTO-XQ97P5U1TE5C",
      dbId: 6,
      label: "Isuzu 2015 (Giovani) VDD DNR",
      registrationNumber: "1ABC127",
      currentDriver: null,
      primaryGroup: "Entire Fleet",
      year: null,
      make: null,
      hasNavigationDevice: false,
      boxOrderNUmber: 1575833,
      imei: 222010424,
      gsm: 5236423211,
      networkType: null,
      garminStatus: null,
      objectRowState: null,
      model: null,
      vin: "",
      classification: "Powered Asset", //Invalid - lastPingDate is empty
      boxName: "VDD",
      vehicleNumber: "AUTO-XQ97P5U1TE5C",
      lastPingDate: "",
    },
    {
      vehicleId: "5050627",
      code: "AUTO-XQ97P5U1TE5L",
      dbId: 8,
      label: "Isuzu 2016 (Giovani) NPA",
      registrationNumber: "1ABC122",
      currentDriver: null,
      primaryGroup: "Entire Fleet",
      year: null,
      make: null,
      hasNavigationDevice: false,
      boxOrderNUmber: 1575833,
      imei: 222010426,
      gsm: 5236123911,
      networkType: null,
      garminStatus: null,
      objectRowState: null,
      model: null,
      vin: "19XFB2F89CE358798",
      classification: "Non-powered Asset", // Invalid - Non-powered Asset
      boxName: "VDD",
      vehicleNumber: "AUTO-XQ97P5U1TE5L",
      lastPingDate: "2025-01-08T13:29:14.238Z",
    },
    {
      vehicleId: "5050666",
      code: "AUTO-XQ97P5U1YE9X",
      dbId: 13,
      label: "2004 International (Garcia) VDD EVC",
      registrationNumber: "1ABC564",
      currentDriver: null,
      primaryGroup: "Entire Fleet",
      year: null,
      make: null,
      hasNavigationDevice: false,
      boxOrderNUmber: 1572832,
      imei: 710100450,
      gsm: 5236823910,
      networkType: null,
      garminStatus: null,
      objectRowState: null,
      model: null,
      vin: "3VVSX7B26PM339365", //Invalid - EVC Detected
      classification: "Vehicle (Default)",
      boxName: "VDD",
      vehicleNumber: "AUTO-XQ97P5U1TE59X",
      lastPingDate: "2025-01-08T13:29:14.238Z",
    },
    {
      vehicleId: "5550675",
      code: "AUTO-XQ55P5U1TEXX",
      dbId: 3,
      label: "2005 International (Garcia) FordTMC",
      registrationNumber: "1ABC542",
      currentDriver: null,
      primaryGroup: "Entire Fleet",
      year: null,
      make: null,
      hasNavigationDevice: false,
      boxOrderNUmber: 1558832,
      imei: 710150450,
      gsm: 5236553110,
      networkType: null,
      garminStatus: null,
      objectRowState: null,
      model: null,
      vin: "3VVSX7B55PM339365", //Invalid - OEM
      classification: "Vehicle (Default)",
      boxName: "FordTMC",
      vehicleNumber: "AUTO-XQ55P5U1TEXX",
      lastPingDate: "2025-01-08T13:29:14.238Z",
    },
    {
      vehicleId: "5550678",
      code: "AUTO-XQ55P5U1TEXX",
      dbId: 3,
      label: "2006 International (Garcia) GM",
      registrationNumber: "1ABC542",
      currentDriver: null,
      primaryGroup: "Entire Fleet",
      year: null,
      make: null,
      hasNavigationDevice: false,
      boxOrderNUmber: 1558832,
      imei: 710150450,
      gsm: 5236553110,
      networkType: null,
      garminStatus: null,
      objectRowState: null,
      model: null,
      vin: "3VVSX7B55PM339365", //Invalid - OEM
      classification: "Vehicle (Default)",
      boxName: "GM",
      vehicleNumber: "AUTO-XQ55P5U1TEXX",
      lastPingDate: "2025-01-08T13:29:14.238Z",
    },
  ],
};
export default VEHICLES_lIST;
